import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import PatientCare from 'components/PatientCare/PatientCare';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from '@material-ui/core/CardHeader';
import GridItem from 'components/Grid/GridItem.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import Typography from '@material-ui/core/Typography';
import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';
import SimpleBasicDialog from 'components/Dialog/SimpleBasicDialog';
import PatientCareForm from 'components/PatientCare/PatientCareForm';
import withStyles from '@material-ui/core/styles/withStyles';
import { Query, Mutation } from 'react-apollo';
import { GET_PATIENT_CARE, UPSERT_PATIENT_CARE, DELETE_PATIENT_CARE } from 'graphql/queries';
import { withTranslation } from 'react-i18next';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    minWidth: 100,
    maxWidth: 200,
  },
  birthday: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  studies: {
    width: 180,
  },
  formLabel: {
    marginTop: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 2,
  },
  delete: {
    justifyContent: 'flex-end',
  },
});

class PatientCareView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      index: null,
    };
  }

  handleAddPatientCare = () => {
    this.setState({
      open: true,
      index: null,
    });
  };

  handleUpdatePatientCare = (e) => {
    this.setState({
      open: true,
      index: e.currentTarget.dataset.index,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { classes, id, t } = this.props;

    return (
      <div>
        <Button variant="outlined" color="primary" onClick={this.handleAddPatientCare}>
          {t('VPatient_AddCare')}
        </Button>

        <Query query={GET_PATIENT_CARE} variables={{ id }} fetchPolicy="cache-and-network">
          {({ loading, error, data }) => {
            if (loading) return <CircularProgress />;
            if (error) return `Error! ${error.message}`;

            return (
              <div>
                <SimpleBasicDialog
                  title={t('VPatient_ConditionCare')}
                  content={
                    <PatientCareForm
                      id={id}
                      mutation={UPSERT_PATIENT_CARE}
                      onClose={this.handleClose}
                      patientCare={data.getPatient.patientCare}
                      index={this.state.index}
                    />
                  }
                  onClose={this.handleClose}
                  open={this.state.open}
                />

                <GridContainer spacing={40}>
                  {data.getPatient.patientCare.map((c, index) => (
                    <GridItem key={id} sm={6} md={4} lg={4}>
                      <Card className={classes.card}>
                        <CardActionArea onClick={this.handleUpdatePatientCare} data-index={index}>
                          <CardHeader
                            title={<Typography noWrap>{c.title}</Typography>}
                            // subheader={c.title}
                            data-_id={id}
                          />
                          <CardBody>
                            <PatientCare patientCare={c} />
                          </CardBody>
                        </CardActionArea>
                        <CardActions className={classes.delete}>
                          <Mutation mutation={DELETE_PATIENT_CARE}>
                            {(deletePatientCare) => (
                              <div>
                                <IconButton
                                  aria-label="Delete"
                                  onClick={deletePatientCare({ variables: { id, title: c.title } })}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </div>
                            )}
                          </Mutation>
                        </CardActions>
                      </Card>
                    </GridItem>
                  ))}
                </GridContainer>
              </div>
            );
          }}
        </Query>
      </div>
    );
  }
}

PatientCareView.propTypes = {
  id: PropTypes.any.isRequired,
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(PatientCareView));
